<template>
  <ul>
    <li class="comment-item" v-for="item in list" :key="item.id">
      <div style="width:500px;">
        <div v-if="item.belong==1">
          <div class="comment-title">{{item.teacher_name+"老师对"+item.nickname+"的点评："}}</div>
          <div class="comment-content-teacher">{{item.content}}</div>
        </div>
        <div v-else>
          <div
            class="comment-title"
            style="margin-bottom:15px;"
          >{{item.nickname+"对"+item.teacher_name+"老师的点评："}}</div>
          <div style="margin-bottom:15px;">
            星级：
            <Rate :value="item.grade" disabled />
          </div>
          <div style="margin-bottom:15px;">
            标签：
            <span class="tag" v-for="tag in item.tags" :key="tag">{{tag}}</span>
          </div>
          <div>内容：{{item.content}}</div>
        </div>
      </div>
      <a @click="deleteComment(item.id)" style="padding-top:20px;">删除</a>
    </li>
  </ul>
</template>
<script>
export default {
  name: "TeachOtoComment",
  data() {
    return {
      list: []
    };
  },
  async created() {
    await this.getData();
  },
  methods: {
    async getData() {
      let list = await this.$http.post("/api/oto/invite/comment", {
        oto_course_id: this.$route.query.oto_course_id,
        user_id: this.$route.query.user_id,
        teacher_id: this.$route.query.teacher_id
      });
      list.forEach(c => {
        if (!c.tag_content) {
          return;
        }
        c.tags = c.tag_content.split(",");
      });
      this.list = list;
    },
    async deleteComment(id) {
      await this.$promiseConfirm(
        "删除后学员和讲师都看不到该评价，确定删除么？"
      );
      await this.$http.delete("/api/oto/invite/comment/" + id);
      this.$Message.deleteSuccess();
      await this.getData();
    }
  }
};
</script>
<style lang="scss" scoped>
.comment-item {
  font-size: 16px;
  margin-bottom: 50px;
  display: flex;
}

.comment-title {
  padding: 20px 0;
}

.comment-content-teacher {
  color: #aaa;
}

.tag {
  padding: 8px 20px;
  border-radius: 20px;
  border: 1px solid #000;
  margin-right: 30px;
}
</style>
